"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("../../store/store");
const dayjs_1 = __importDefault(require("dayjs"));
const usePrevious_1 = __importDefault(require("../../hooks/usePrevious"));
const utils_1 = require("../../helpers/utils");
const bookingSlice_1 = require("../../store/slices/bookingSlice");
const ComingAppointments_1 = __importDefault(require("./components/ComingAppointments"));
const LoadingButton_1 = __importDefault(require("../../components/LoadingButton"));
const useHandleBooking_1 = __importDefault(require("../../hooks/useHandleBooking"));
const BookingFlow_1 = __importDefault(require("./components/BookingFlow"));
const lodash_1 = require("lodash");
const bookingChoices = ['donationType', 'locationId', 'calendarId'];
const Booking = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { openBookingFlow, bookingFlowType, toggleBookingModal, isModalOpen, setBookingFlowType } = (0, useHandleBooking_1.default)();
    const { currentBooking, currentStepIndex } = (0, store_1.useAppSelector)((state) => state.booking);
    const userCanMakeAppointment = (0, store_1.useAppSelector)((state) => (0, bookingSlice_1.canUserMakeAppointment)(state));
    const [updateBooking, setUpdateBooking] = (0, react_1.useState)(undefined);
    const prevBooking = (0, usePrevious_1.default)(currentBooking);
    const [isLoading] = (0, react_1.useState)(false);
    const [selectedAppointment, setSelectedAppointment] = (0, react_1.useState)(null);
    const handleAppointmentSelect = (appointment, mode) => {
        setSelectedAppointment(appointment);
        openBookingFlow(mode);
    };
    (0, react_1.useEffect)(() => {
        if (!isModalOpen) {
            setSelectedAppointment(null);
        }
    }, [isModalOpen]);
    (0, react_1.useEffect)(() => {
        return () => {
            dispatch((0, bookingSlice_1.clearCurrentBooking)());
        };
    }, [dispatch]);
    (0, react_1.useEffect)(() => {
        const currentSize = _(currentBooking).pick(bookingChoices).values().compact().size();
        const prevSize = _(prevBooking).pick(bookingChoices).values().compact().size();
        if (prevSize >= currentSize && currentSize > 0) {
            const changedKey = (0, lodash_1.first)((0, utils_1.changedKeys)(currentBooking, prevBooking));
            if (typeof changedKey === 'string') {
                const changedKeyIndex = bookingChoices.indexOf(changedKey);
                const booking = Object.assign({}, currentBooking);
                if (changedKeyIndex === -1) {
                    return;
                }
                if ((0, lodash_1.isEqual)(updateBooking, prevBooking)) {
                    setUpdateBooking(undefined);
                }
                else if (!(0, lodash_1.isEqual)(updateBooking, booking)) {
                    _(bookingChoices)
                        .drop(changedKeyIndex + 1)
                        .each((o) => {
                        (0, lodash_1.set)(booking, o, undefined);
                    });
                    booking.date = {
                        selectedDate: undefined,
                        selectedTime: undefined,
                        currentCalendarYear: (0, dayjs_1.default)().get('year'),
                        currentCalendarMonth: (0, dayjs_1.default)().get('month'),
                    };
                    booking.slotId = undefined;
                    dispatch((0, bookingSlice_1.setCurrentBooking)(booking));
                    dispatch((0, bookingSlice_1.setStepIndex)(0));
                    setUpdateBooking(booking);
                }
            }
        }
    }, [currentBooking, updateBooking, dispatch, prevBooking]);
    const renderReasons = (0, react_1.useMemo)(() => _(userCanMakeAppointment)
        .flatMap((o) => o.reason)
        .uniq()
        .compact()
        .map((r) => ((0, jsx_runtime_1.jsx)("p", { children: r === 'hasMaxNumAppointments'
            ? __.trans('booking.not-allowed-to-book-reason-max-num')
            : __.trans('booking.not-allowed-to-book-reason-need-to-wait') }, r)))
        .value(), [userCanMakeAppointment]);
    return ((0, jsx_runtime_1.jsxs)("div", { id: "booking", children: [(0, jsx_runtime_1.jsx)(ComingAppointments_1.default, { className: "mb-5", onAppointmentSelect: handleAppointmentSelect }), (userCanMakeAppointment === null || userCanMakeAppointment === void 0 ? void 0 : userCanMakeAppointment.allowed) || currentStepIndex === 2 ? ((0, jsx_runtime_1.jsx)(LoadingButton_1.default, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-sm theme-button-primary handle-booking", onClick: () => openBookingFlow('book'), children: __.trans('booking.book-new-appointment') }) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { children: __.trans('booking.not-allowed-to-book') }), renderReasons] })), (0, jsx_runtime_1.jsx)(BookingFlow_1.default, { bookingFlowType: bookingFlowType, appointment: selectedAppointment, toggleBookingModal: toggleBookingModal, isModalOpen: isModalOpen, setBookingFlowType: setBookingFlowType })] }));
};
exports.default = Booking;
